import gql from "graphql-tag";

const SelfDisClosureQuery = gql`
query getSelfDisclosureLandingPage($digitalOrderingId: String!, $password: String!) {
    selfDisclosureLandingPage(digitalOrderingId: $digitalOrderingId, password: $password) {
        available,
        error,
        salesType,
        data {
            gender,
            firstName,
            lastName,
            phone,
            birthday,
            birthName,
            nationality,
            birthCountry,
            birthPlace,
            civilStatus,
            street,
            streetNumber,
            zipCode,
            city,
            country,
            residingSince,
            occupationType,
            employer,
            employmentSince,
            monthlyNetIncome1,
            monthlyNetIncome2,
            monthlyNetIncome3,
            monthlyNetIncomePartner,
            monthlyIncomeRenting,
            monthlyIncomeOther,
            iban,
            bic,
            type,
            company,
            legalForm,
            foundingDate
        },
        info {
            requiresOverviewPage,
            requiresTermsPage,
            offer {
                term,
                mileage,
                monthlyRateTotal,
                specialPayment,
                contractType
            },
            vehicle {
                name,
                horsePower,
                imageUrl
            }
        }
    }
}
`;

export default SelfDisClosureQuery;
